import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "fileName", "dropZone"]

  handleFileSelect() {
    const file = this.inputTarget.files[0]
    if (file) {
      this.fileNameTarget.textContent = file.name
      this.fileNameTarget.classList.remove("hidden")
      this.dropZoneTarget.classList.add("border-accent-green", "bg-accent-green", "bg-opacity-5")
      this.dropZoneTarget.classList.remove("border-primary")
    }
  }
}
